module.exports = __webpack_public_path__ + "assets/time.809df2f6.svg";